import { GxVirtualKeyCardInReservation } from '@mews-commander/data-access';
import { useDigitalKeyStatusQuery } from '../query/useDigitalKeyStatusQuery';

export const useReservationsWithDKReady = (reservationIds: string[]) => {
    const { data } = useDigitalKeyStatusQuery(reservationIds);

    return (
        data?.reservationDigitalKeyStatusResults
            ?.filter((result) => result.status === GxVirtualKeyCardInReservation.AlreadyIssued)
            .map((result) => result.reservationId) || []
    );
};
